import * as React from 'react'

export const AccountActivationSuccess = () => (
  <>
    <h4 className="text-secondary fw-bold text-center mt-5 mb-2">Twoje konto Gościa zostało poprawnie aktywowane.</h4>
    <p className="mb-4 mt-3 text-center font-size-12">Możesz się już zalogować do swojego Konta Gościa</p>
  </>
)
